var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { GET_PORTAL_URL } from "./queries";
/**
 * Helper to construct the return URL for Stripe portal redirect
 */
var makeRedirectPath = function (customPathname) {
    if (customPathname) {
        return window.location.origin + customPathname;
    }
    // window.location.toString() returns the full URL including origin, pathname, search, and hash
    return window.location.toString();
};
/**
 * Custom hook to handle Stripe Customer Portal link logic
 *
 * @example
 * // Using with Button component
 * const AddPaymentButton = () => {
 *   const { requestRedirect, isProcessing, hasError } = useStripePortalLink();
 *   return (
 *     <Button onClick={requestRedirect} disabled={isProcessing}>
 *       {hasError ? "Failed to Load" : "Add Payment Method"}
 *     </Button>
 *   );
 * };
 *
 * @example
 * // Using with custom redirect
 * const { requestRedirect } = useStripePortalLink({
 *   redirectPath: "/dashboard/billing"
 * });
 */
var useStripePortalLink = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.client, client = _c === void 0 ? null : _c, _d = _b.redirectPath, redirectPath = _d === void 0 ? "" : _d, _e = _b.organizationId, organizationId = _e === void 0 ? null : _e;
    var _f = useState(false), isProcessing = _f[0], setIsProcessing = _f[1];
    var _g = useState(false), hasError = _g[0], setHasError = _g[1];
    var _h = useLazyQuery(GET_PORTAL_URL, {
        client: client,
    }), fetchPortalLink = _h[0], data = _h[1].data;
    var requestRedirect = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isProcessing) {
                return [2 /*return*/];
            }
            setIsProcessing(true);
            fetchPortalLink({
                variables: {
                    returnUrl: makeRedirectPath(redirectPath),
                    organizationId: organizationId,
                },
                fetchPolicy: "no-cache",
            });
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        if (isProcessing && data) {
            if (!data.stripeCustomerPortalUrl ||
                data.stripeCustomerPortalUrl.error ||
                !data.stripeCustomerPortalUrl.url) {
                setHasError(true);
            }
            else {
                window.location.href = data.stripeCustomerPortalUrl.url;
            }
            setIsProcessing(false);
        }
    }, [isProcessing, data]);
    return {
        requestRedirect: requestRedirect,
        isProcessing: isProcessing,
        hasError: hasError,
    };
};
export default useStripePortalLink;
